import { Alert, Modal } from 'antd';
import { useCancelSubscriptionMutation } from 'api/PaymentApi';
import SpinComponent from 'components/Tool/SpinComponent/SpinComponent';
import { useSelector } from 'react-redux';
import { closeModal, selectModalData, selectModalName } from 'store/modalSlice';
import { useAppDispatch } from 'store/store';
import { getResponseErrors } from 'utils/utils';
import './CancelSubscriptionModalComponent.css';

export const CANCEL_SUBSCRIPTION_MODAL_NAME = 'CANCEL_SUBSCRIPTION_MODAL_NAME';

type AllProps = {
  onOk?: () => void;
};

function CancelSubscriptionModalComponent({ onOk }: AllProps) {
  const dispatch = useAppDispatch();
  const [cancelSubscription, { isLoading, error }] = useCancelSubscriptionMutation();

  const handleCancel = async () => {
    try {
      const result = await cancelSubscription().unwrap();
      if (result) {
        onOk && onOk();
      }
      handleCloseModal();
    } catch (e) {}
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      open={true}
      title="Cancel Subscription"
      onOk={handleCancel}
      onCancel={handleCloseModal}
      okText="Update"
      confirmLoading={isLoading}
      className="size-sm"
    >
      <SpinComponent isLoading={isLoading}>
        <div className="cancel-subscription-modal-component">
          {error && <Alert className="message" message={getResponseErrors(error).join(', ')} type="error" showIcon />}
          <p>Do you want to Cancel Subscription?</p>
        </div>
      </SpinComponent>
    </Modal>
  );
}

function CancelSubscriptionModalComponentWrapper() {
  const modalName = useSelector(selectModalName);
  const modalData = useSelector(selectModalData);
  const onOk = modalData?.onOk || null;

  return modalName === CANCEL_SUBSCRIPTION_MODAL_NAME ? <CancelSubscriptionModalComponent onOk={onOk} /> : null;
}

export default CancelSubscriptionModalComponentWrapper;
